import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../entities/ErrorEntity";
import SearchResultEntity from "../entities/SearchResultEntity";
import UserEntity, { UserType } from "../entities/UserEntity";

export default interface UserRepository {
    createUser(_: {
        user: UserEntity,
        password: string,
    }): Promise<Either<ErrorEntity, UserEntity>>;
    searchUsers(_: {
        query?: string, page: number, itemsPerPage: number,
        role?: UserType
    }): Promise<Either<ErrorEntity, SearchResultEntity<UserEntity>>>;
    getUserById(id: string): Promise<Either<ErrorEntity, UserEntity>>;
    deleteUser(id: string): Promise<Either<ErrorEntity, void>>;
    updateUser(_: {
        user: UserEntity,
        password?: string,
    }): Promise<Either<ErrorEntity, UserEntity>>;
    searchUsersForShift(_:{query?: string, scheduleId: string, date: Date}): Promise<Either<ErrorEntity, UserEntity[]>>;
}

export const UserRepositoryName = "UserRepository";